import { Event } from "../../../base/common/events.js";
import { createDecorator } from "../../instantiation/common/registry.js";
import { IEditorWindow } from "../../window/browser/window.js";


export const IWindowsMainService = createDecorator<IWindowsMainService>('windowsMainService');


export interface IWindowsMainService {
	readonly _serviceBrand: undefined;

	readonly allowPopout: boolean;

	readonly onDidOpenWindow: Event<IEditorWindow>;
	readonly onDidDestroyWindow: Event<IEditorWindow>;

	open(openConfig: IOpenConfiguration): Promise<IEditorWindow[]>;

	captureWindowState(id: string, window: Window): Promise<void>;

	getWindows(): IEditorWindow[];
}


export const enum OpenContext {

	// opening when running from the command line
	CLI,

	// macOS only: opening from the dock (also when opening files to a running instance from desktop)
	DOCK,

	// opening from the main application window
	MENU,

	// opening from a file or folder dialog
	DIALOG,

	// opening from the OS's UI
	DESKTOP,

	// opening through the API
	API,

	// opening from a protocol link
	LINK
}


export interface IBaseOpenConfiguration {
	readonly context: OpenContext;
	readonly contextWindowId?: number;

	/**
	 * Optional unique identifier for the window.
	 */
	id?: string;
	/**
	 * Optional view identifier.
	 */
	view?: string

	/**
	 * If true the window will attempt to restore its previous state (size, position, workspace) if any.
	 * @requires id to be set.
	 */
	restorePreviousState?: boolean;
}

export interface IOpenConfiguration extends IBaseOpenConfiguration {
	title?: string;
	expectedSize?: { width?: number, height?: number };
	expectedPosition?: { x?: number, y?: number };
	url?: string;
}
